import type { ContactLink } from './types';

export const contactLinks: ContactLink[] = [
  {
    id: 'linkedin',
    url: 'https://www.linkedin.com/in/danilo-targas-b749bb13b/',
    target: '_blank',
    class: 'linkedin',
    icon: 'fab fa-linkedin-in',
    i18n: { 'pt-BR': { label: 'LinkedIn' }, en: { label: 'LinkedIn' } },
  },
  {
    id: 'email',
    url: 'mailto:danilorodriguestargas@gmail.com',
    icon: 'far fa-envelope',
    i18n: { 'pt-BR': { label: 'E-Mail' }, en: { label: 'Email' } },
  },
  {
    id: 'whatsapp',
    url: 'https://wa.me/5511987916822',
    target: '_blank',
    icon: 'fab fa-whatsapp',
    i18n: { 'pt-BR': { label: 'WhatsApp' }, en: { label: 'WhatsApp' } },
  },
  {
    id: 'codepen',
    url: 'https://codepen.io/targas',
    target: '_blank',
    icon: 'fab fa-codepen',
    i18n: { 'pt-BR': { label: 'Codepen' }, en: { label: 'CodePen' } },
  },
];

export const CV_PATHS = {
  pdf: '/CV-Danilo-Targas.pdf',
  docx: '/CV-Danilo-Targas.docx',
} as const;
